<div
  class="assign-icon"
  [ngClass]="{'inactive': !active}"
  [matTooltip]="tooltipText"
>
  <mat-icon>{{ icon }}</mat-icon>
</div>
